import NavigationTabs, { NavigationTab } from "components/NavigationTabs";
import React from "react";

export enum ResearchHubTab {
  Lists = "lists",
  Uploaded = "uploaded",
}

interface ResearchHubNavigationProps {
  selectedTab: ResearchHubTab;
  onTabClick: (tab: ResearchHubTab) => void;
  className?: string;
}

export const ResearchHubNavigation: React.FC<ResearchHubNavigationProps> = ({
  selectedTab,
  onTabClick,
  className = "",
}) => {
  const tabs: NavigationTab[] = [
    {
      id: ResearchHubTab.Lists,
      label: "Lists",
      icon: "icon-book-marked",
    },
    {
      id: ResearchHubTab.Uploaded,
      label: "Uploaded Papers",
      icon: "icon-file-arrow-up",
    },
  ];

  const handleTabClick = (tabId: string) => {
    onTabClick(tabId as ResearchHubTab);
  };

  return (
    <NavigationTabs
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={handleTabClick}
      className={className}
      sticky={true}
    />
  );
};

export default ResearchHubNavigation;
